export const jointScenarioQueryKeys = {
  forecast: `joint_scenario_forecast`,
  notes: `joint_scenario_notes`,
  assetAllocation: `joint_scenario_asset_allocation`,
  jointBudget: `joint_scenario_joint_budget`,
  jointCashflowEvents: `joint_scenario_joint_cashflow_events`,
}
